// JsFromRoutes CacheKey 1f867eecbe3166bc4cdd9c21ac769a7f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  sendInvoice: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/payments/:id/send_invoice'),
  chargeSavedCard: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/payments/charge_saved_card'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/:venue_slug/:payable_type/:payable_id/payments'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/:venue_slug/:payable_type/:payable_id/payments/:id'),
}
